<span fxLayout="row" *ngIf="!isSelected || item.preventEdit">
    <span *ngIf="item.control === 'checkbox'">
        <!-- <mat-slide-toggle [checked]="getFieldValue()" [disabled]="true"></mat-slide-toggle> -->
        <mat-checkbox [checked]="getFieldValue()" [disabled]="true"></mat-checkbox>
    </span>
    <span *ngIf="item.control !== 'checkbox'" style="padding-top: 10px;">
        {{value}}
    </span>
</span>
<app-field-editor [config]="item" 
    [control]="getControl(item)"
    *ngIf="isSelected && !item.preventEdit ">
</app-field-editor>